"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-nested-ternary */
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const redux_1 = require("redux");
const assets_1 = require("~/assets");
const UI_1 = require("~/components/UI");
const routes_1 = require("~/consts/routes");
const useWindowDimensions_1 = __importDefault(require("~/hooks/useWindowDimensions"));
const actions_1 = require("~/store/actions");
const selectors_1 = require("~/store/selectors");
const events_1 = require("~/utils/events");
const getClosestToBOMWidgetPosition_1 = __importDefault(require("~/utils/getClosestToBOMWidgetPosition"));
const utils_1 = require("~/utils/utils");
const roundNumberWithDecimals_1 = __importDefault(require("~/utils/roundNumberWithDecimals"));
const consts_1 = require("~/consts/consts");
const consts_2 = require("~/store/consts");
const types_1 = require("~/store/types");
const types_2 = require("~/store/loading/types");
const useProjectStatus_1 = __importDefault(require("~/hooks/useProjectStatus"));
const useProjectItemPath_1 = __importDefault(require("~/hooks/useProjectItemPath"));
const consts_3 = require("~/store/account/consts");
const consts_4 = require("~/components/Cad3d/consts");
const BOMItemsList_1 = __importDefault(require("./BOMItemsList"));
const BOMTotal_1 = __importDefault(require("./BOMTotal"));
const BOMExportButton_1 = __importDefault(require("./BOMExportButton"));
const BOMWidget_scss_1 = __importDefault(require("./BOMWidget.scss"));
const BOMShareButton_1 = __importDefault(require("./BOMShareButton"));
const index_1 = require("./BOMSearchUtils/index");
function BOMWidget() {
    var _a, _b, _c;
    const { dispatchSelectItem, dispatchSocketBOM, dispatchToggleQuote, dispatchToggleWidget, dispatchUpdateWidgetPosition, dispatchUpdateWidgetSize, dispatchEditMode, dispatchDeleteManuallyAdded, dispatchAddItemQuantity, dispatchAddManuallyAddedMachiningServiceQuantity, dispatchAddItemSize, dispatchSetEmptyBOM, dispatchSetAssemblyChargeIncluded, dispatchSetAssemblyChargeIncludedItems, dispatchGroupManuallyAddedItems, dispatchSetBOMLoading, dispatchSetDiscountedPriceShown, } = (0, redux_1.bindActionCreators)({
        dispatchSelectItem: actions_1.selectItem,
        dispatchSocketBOM: actions_1.requestSocketBOM,
        dispatchToggleQuote: actions_1.toggleQuote,
        dispatchToggleWidget: actions_1.toggleWidget,
        dispatchUpdateWidgetPosition: actions_1.updateWidgetPosition,
        dispatchUpdateWidgetSize: actions_1.updateWidgetSize,
        dispatchEditMode: actions_1.editMode,
        dispatchDeleteManuallyAdded: actions_1.deleteManuallyAdded,
        dispatchAddItemQuantity: actions_1.addItemQuantity,
        dispatchAddManuallyAddedMachiningServiceQuantity: actions_1.addManuallyAddedMachiningServiceQuantity,
        dispatchAddItemSize: actions_1.addItemSize,
        dispatchSetEmptyBOM: actions_1.setEmptyBOM,
        dispatchSetAssemblyChargeIncluded: actions_1.setAssemblyChargeIncluded,
        dispatchSetAssemblyChargeIncludedItems: actions_1.setAssemblyChargeIncludedItems,
        dispatchGroupManuallyAddedItems: actions_1.groupManuallyAddedItems,
        dispatchSetBOMLoading: actions_1.setBOMLoading,
        dispatchSetDiscountedPriceShown: actions_1.setDiscountedPriceShown,
    }, (0, react_redux_1.useDispatch)());
    const isImperialMeasurement = (0, react_redux_1.useSelector)(selectors_1.selectIsImperialMeasurementUsed);
    const projectId = (0, react_redux_1.useSelector)(selectors_1.selectCurrentProjectId);
    const projectPermissions = (_a = (0, react_redux_1.useSelector)(selectors_1.selectCurrentProject)) === null || _a === void 0 ? void 0 : _a.permissions;
    const isEditMode = (0, react_redux_1.useSelector)(selectors_1.selectBOMEditMode);
    const BOMWidgetState = (0, react_redux_1.useSelector)((0, selectors_1.selectWidgetState)(consts_2.WIDGETS.BOM_WIDGET));
    const manuallyAddedItems = (0, react_redux_1.useSelector)(selectors_1.selectManuallyAddedItems);
    const { isBomSubmitDisabled, isLoading, bom, feedback } = (0, react_redux_1.useSelector)(selectors_1.selectBOM);
    const isExporting = (0, react_redux_1.useSelector)(selectors_1.selectBOMExporting);
    const isBOMFeedbackVisible = (feedback === null || feedback === void 0 ? void 0 : feedback.projectId) === projectId && (isLoading === types_2.LOADING_STATE.LOADING || (feedback === null || feedback === void 0 ? void 0 : feedback.failed));
    const isWidgetLoading = !isExporting && (isLoading === types_2.LOADING_STATE.LOADING || isBOMFeedbackVisible);
    const isUserLogged = (0, react_redux_1.useSelector)(selectors_1.selectIsUserLogged);
    const manuallyDeletedItems = (0, react_redux_1.useSelector)(selectors_1.selectManuallyDeletedItems);
    const manuallyAddedQuantity = (0, react_redux_1.useSelector)(selectors_1.selectBOMItemsQuantity);
    const manuallyAddedSize = (0, react_redux_1.useSelector)(selectors_1.selectBOMItemsSize);
    const manuallySavedItems = (0, react_redux_1.useSelector)(selectors_1.selectManuallySavedItems);
    const manuallySavedMachiningServices = (0, react_redux_1.useSelector)(selectors_1.selectManuallySavedMachiningServices);
    const manuallyAddedMachiningServices = (0, react_redux_1.useSelector)(selectors_1.selectManuallyAddedMachiningServices);
    const manuallyDeletedMachiningServices = (0, react_redux_1.useSelector)(selectors_1.selectManuallyDeletedMachiningServices);
    const manuallyAddedMachiningServicesQuantity = (0, react_redux_1.useSelector)(selectors_1.selectManuallyAddedMachiningServicesQuantity);
    const userId = (0, react_redux_1.useSelector)(selectors_1.selectUserId);
    const isProjectItemPath = (0, useProjectItemPath_1.default)(projectId);
    const isDefaultFastenersWidgetShown = (0, react_redux_1.useSelector)((0, selectors_1.selectIsWidgetShown)(consts_2.WIDGETS.DEFAULT_FASTENER_WIDGET));
    const isCurrentFastenersWidgetShown = (0, react_redux_1.useSelector)((0, selectors_1.selectIsWidgetShown)(consts_2.WIDGETS.CURRENT_FASTENER_WIDGET));
    const isItemReplacementWidgetShown = (0, react_redux_1.useSelector)((0, selectors_1.selectIsWidgetShown)(consts_2.WIDGETS.ITEM_REPLACEMENT_WIDGET));
    const userRole = (0, react_redux_1.useSelector)(selectors_1.selectCurrentUserRole);
    const { isOrderCompleted, isProjectArchived, isProjectViewOnly } = (0, useProjectStatus_1.default)();
    const [isUpdated, setIsUpdated] = (0, react_1.useState)(false);
    const [explosionCoefficient, setExplosionCoefficient] = (0, react_1.useState)(consts_4.consts.SCREENSHOT_EXPLODED_VIEW_OFFSET);
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { t } = (0, react_i18next_1.useTranslation)('widgets');
    const { width } = (0, useWindowDimensions_1.default)();
    const inputRef = (0, react_1.useRef)(null);
    const [bomSearchText, setBomSearchText] = (0, react_1.useState)('');
    const [isSearching, setIsSearching] = (0, react_1.useState)(false);
    const [filteredData, setFilteredData] = (0, react_1.useState)({
        groups: (bom === null || bom === void 0 ? void 0 : bom.groups) || [],
        assemblyCharge: (bom === null || bom === void 0 ? void 0 : bom.assemblyCharge) && Object.keys(bom.assemblyCharge).length > 0 ? bom.assemblyCharge : undefined,
    });
    (0, react_1.useEffect)(() => {
        if (bomSearchText.trim()) {
            setIsSearching(true);
            setFilteredData((0, index_1.filterBOMAndAssemblyChargeBySearchText)((bom === null || bom === void 0 ? void 0 : bom.groups) || [], bom === null || bom === void 0 ? void 0 : bom.assemblyCharge, bomSearchText));
        }
        else {
            setIsSearching(false);
            setFilteredData({
                groups: (bom === null || bom === void 0 ? void 0 : bom.groups) || [],
                assemblyCharge: (bom === null || bom === void 0 ? void 0 : bom.assemblyCharge) && Object.keys(bom.assemblyCharge).length > 0 ? bom.assemblyCharge : undefined,
            });
        }
    }, [bomSearchText, bom === null || bom === void 0 ? void 0 : bom.groups, bom === null || bom === void 0 ? void 0 : bom.assemblyCharge]);
    (0, react_1.useEffect)(() => {
        if (projectId && isLoading !== types_2.LOADING_STATE.LOADING) {
            dispatchSocketBOM({ projectId, userId });
        }
    }, [projectId]);
    (0, react_1.useEffect)(() => {
        if (bom && bom.projectId !== projectId) {
            dispatchSetEmptyBOM();
        }
    }, [bom]);
    (0, react_1.useEffect)(() => {
        var _a;
        const discountType = (_a = bom === null || bom === void 0 ? void 0 : bom.discount) === null || _a === void 0 ? void 0 : _a.type;
        const isUserCustomer = userRole === consts_3.UserRoles.customer && discountType === consts_1.DISCOUNT_TYPE.CUSTOMER;
        if (isUserCustomer) {
            dispatchSetDiscountedPriceShown(true);
        }
    }, [userRole, dispatchSetDiscountedPriceShown]);
    (0, react_1.useEffect)(() => {
        setIsUpdated(true);
    }, [(_b = bom === null || bom === void 0 ? void 0 : bom.assemblyCharge) === null || _b === void 0 ? void 0 : _b.items]);
    (0, react_1.useEffect)(() => {
        if (isEditMode) {
            setIsUpdated(false);
            dispatchUpdateWidgetPosition({
                widgetName: consts_2.WIDGETS.CATALOG_WIDGET_EDIT_MODE,
                position: (0, getClosestToBOMWidgetPosition_1.default)(BOMWidgetState),
            });
            dispatchUpdateWidgetSize({
                widgetName: consts_2.WIDGETS.CATALOG_WIDGET_EDIT_MODE,
                size: {
                    width: UI_1.widgetMinWidth,
                    height: BOMWidgetState.size.height,
                },
            });
            dispatchToggleWidget({
                widgetName: consts_2.WIDGETS.CATALOG_WIDGET_EDIT_MODE,
                show: true,
            });
            dispatchToggleWidget({
                widgetName: consts_2.WIDGETS.CATALOG_WIDGET,
                show: false,
            });
        }
        else {
            setIsUpdated(false);
            dispatchToggleWidget({
                widgetName: consts_2.WIDGETS.CATALOG_WIDGET_EDIT_MODE,
                show: false,
            });
            dispatchToggleWidget({
                widgetName: consts_2.WIDGETS.CATALOG_WIDGET,
                show: isProjectItemPath ? !(isOrderCompleted || isProjectArchived || isProjectViewOnly) : true,
            });
        }
    }, [isEditMode]);
    (0, react_1.useEffect)(() => {
        if (BOMWidgetState.show && bom && (bom === null || bom === void 0 ? void 0 : bom.quantity) > 0 && !isUserLogged) {
            navigate(routes_1.ROUTE_LOGIN, { state: { msg: 'Please sign in to view BOM' } });
            dispatchToggleWidget({
                widgetName: consts_2.WIDGETS.BOM_WIDGET,
                show: false,
            });
        }
    }, [BOMWidgetState.show, bom === null || bom === void 0 ? void 0 : bom.quantity]);
    (0, react_1.useEffect)(() => {
        if (isEditMode && !BOMWidgetState.show) {
            dispatchToggleWidget({
                widgetName: consts_2.WIDGETS.CATALOG_WIDGET_EDIT_MODE,
                show: false,
            });
        }
        if (isEditMode && BOMWidgetState.show) {
            dispatchToggleWidget({
                widgetName: consts_2.WIDGETS.CATALOG_WIDGET_EDIT_MODE,
                show: true,
            });
        }
    }, [BOMWidgetState.show, isEditMode]);
    (0, react_1.useEffect)(() => {
        setIsUpdated(true);
    }, [manuallyAddedItems, bom === null || bom === void 0 ? void 0 : bom.quantity]);
    const handleAddItemsClick = () => {
        var _a, _b;
        if (!isUserLogged && BOMWidgetState.show) {
            navigate(routes_1.ROUTE_LOGIN);
        }
        else {
            if (((_b = (_a = bom === null || bom === void 0 ? void 0 : bom.groups) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) > 0) {
                bom.groups.forEach((group) => {
                    group.items.forEach((item) => {
                        var _a, _b, _c, _d, _e;
                        if (item.manuallyAdded) {
                            const uuid = (_b = (_a = item.uuid) === null || _a === void 0 ? void 0 : _a.at(0)) !== null && _b !== void 0 ? _b : '';
                            dispatchAddItemQuantity({ value: (_c = item.quantity) !== null && _c !== void 0 ? _c : 1, uuid });
                            dispatchAddItemSize({ value: (_d = item.size) !== null && _d !== void 0 ? _d : 1, uuid });
                            (_e = item.services) === null || _e === void 0 ? void 0 : _e.forEach((service) => {
                                var _a;
                                return dispatchAddManuallyAddedMachiningServiceQuantity({
                                    projectItemUUID: uuid,
                                    serviceId: service.id,
                                    quantity: (_a = service.quantity) !== null && _a !== void 0 ? _a : 1,
                                });
                            });
                        }
                    });
                });
            }
            dispatchEditMode(!isEditMode);
        }
        handleSearchReset();
    };
    const collectServicesForDeletedItem = (item, manuallyDeletedServices) => {
        var _a;
        const services = [];
        const itemServices = (_a = item.services) === null || _a === void 0 ? void 0 : _a.map((service) => ({
            machiningServiceId: service.id,
            quantity: service.quantity,
            notes: service.notes,
        }));
        if (itemServices === null || itemServices === void 0 ? void 0 : itemServices.length) {
            services.push(...itemServices);
        }
        const itemDeletedServices = manuallyDeletedServices === null || manuallyDeletedServices === void 0 ? void 0 : manuallyDeletedServices.map((service) => ({
            machiningServiceId: service.machiningServiceId,
            quantity: service.quantity,
            notes: service.notes,
        }));
        if (itemDeletedServices === null || itemDeletedServices === void 0 ? void 0 : itemDeletedServices.length) {
            services.push(...itemDeletedServices);
        }
        return services;
    };
    const cancelClickHandle = () => {
        Object.keys(manuallyAddedItems).forEach((key) => {
            const item = manuallyAddedItems[key];
            document.body.dispatchEvent((0, events_1.removeItemsFromBOMEvent)([
                {
                    actionType: types_1.ACTION_TYPE.REMOVE,
                    itemNumber: item.item_number,
                    manuallyAdded: true,
                    size: item.size,
                    quantity: item.quantity,
                    uuid: item.uuid ? item.uuid[0] : undefined,
                },
            ]));
            dispatchDeleteManuallyAdded(key);
        });
        Object.keys(manuallyDeletedItems).forEach((key) => {
            const item = manuallyDeletedItems[key];
            const services = collectServicesForDeletedItem(item, manuallyDeletedMachiningServices[key]);
            document.body.dispatchEvent((0, events_1.addItemsToBOMEvent)([
                {
                    actionType: types_1.ACTION_TYPE.ADD,
                    itemNumber: item.item_number,
                    size: item.size || 1,
                    panelSize: item.panelSize,
                    manuallyAdded: true,
                    uuid: item.uuid ? item.uuid[0] : undefined,
                    quantity: item.quantity,
                    services,
                    createdAt: item.createdAt,
                },
            ]));
        });
        Object.keys(manuallyAddedQuantity).forEach((key) => {
            const quantity = manuallyAddedQuantity[key];
            if (manuallySavedItems[key] && manuallySavedItems[key].quantity !== quantity) {
                document.body.dispatchEvent((0, events_1.updateItemsToBOMEvent)([
                    {
                        uuid: key,
                        quantity,
                        actionType: types_1.ACTION_TYPE.UPDATE,
                        connections: [],
                    },
                ]));
            }
        });
        Object.keys(manuallyAddedSize).forEach((key) => {
            const size = manuallyAddedSize[key];
            const item = manuallySavedItems[key];
            if (item && (0, utils_1.isSizeChangable)(item) && item.size && item.size !== size) {
                document.body.dispatchEvent((0, events_1.updateItemsToBOMEvent)([
                    {
                        uuid: key,
                        size,
                        actionType: types_1.ACTION_TYPE.UPDATE,
                        connections: [],
                    },
                ]));
            }
        });
        Object.keys(manuallyAddedMachiningServices).forEach((key) => {
            const machiningServices = manuallyAddedMachiningServices[key];
            machiningServices.forEach((machiningService) => {
                document.body.dispatchEvent((0, events_1.removeServicesFromBOMEvent)([
                    {
                        machiningServiceId: machiningService.machiningServiceId,
                        projectItemUUID: machiningService.projectItemUUID,
                    },
                ]));
            });
        });
        Object.keys(manuallyDeletedMachiningServices).forEach((key) => {
            if (!Object.hasOwn(manuallyDeletedItems, key)) {
                const machiningServices = manuallyDeletedMachiningServices[key];
                machiningServices.forEach((machiningService) => {
                    document.body.dispatchEvent((0, events_1.addServicesToBOMEvent)([
                        {
                            machiningServiceId: machiningService.machiningServiceId,
                            projectItemUUID: machiningService.projectItemUUID,
                            quantity: machiningService.quantity,
                            notes: machiningService.notes,
                        },
                    ]));
                });
            }
        });
        Object.keys(manuallyAddedMachiningServicesQuantity).forEach((key) => {
            const machiningServices = manuallyAddedMachiningServicesQuantity[key];
            if (manuallySavedMachiningServices[key]) {
                machiningServices.forEach((machiningService) => {
                    const { quantity } = machiningService;
                    const savedService = manuallySavedMachiningServices[key].find((service) => service.machiningServiceId === machiningService.serviceId);
                    if (savedService && (savedService === null || savedService === void 0 ? void 0 : savedService.quantity) !== quantity) {
                        document.body.dispatchEvent((0, events_1.updateServicesToBOMEvent)([
                            {
                                machiningServiceId: machiningService.serviceId,
                                projectItemUUID: machiningService.projectItemUUID,
                                quantity: machiningService.quantity,
                            },
                        ]));
                    }
                });
            }
        });
        dispatchEditMode(!isEditMode);
        dispatchSelectItem(null);
    };
    const saveClickHandle = () => {
        var _a, _b;
        if (isEditMode) {
            dispatchEditMode(!isEditMode);
            dispatchSelectItem(null);
            Object.keys(manuallyAddedItems).forEach((key) => {
                dispatchDeleteManuallyAdded(key);
            });
            if (projectId && userId) {
                dispatchGroupManuallyAddedItems({ projectId, userId });
                const assemblyChargeItemsToUpdate = (_b = (_a = bom === null || bom === void 0 ? void 0 : bom.assemblyCharge) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b.map((item) => {
                    var _a;
                    return ({
                        projectItemId: item.id,
                        isAssemblyChargeIncluded: (_a = item.isAssemblyChargeIncluded) !== null && _a !== void 0 ? _a : false,
                        projectId,
                        userId,
                    });
                });
                if (assemblyChargeItemsToUpdate) {
                    dispatchSetAssemblyChargeIncludedItems(assemblyChargeItemsToUpdate);
                    dispatchSetBOMLoading();
                }
            }
            return;
        }
        dispatchToggleQuote(true);
    };
    const handleSetAssemblyChargeIncluded = (isAssemblyChargeIncluded) => {
        if (bom && bom.id && userId) {
            const data = {
                quoteId: bom.id,
                projectId: bom.projectId,
                userId,
                isAssemblyChargeIncluded,
            };
            dispatchSetAssemblyChargeIncluded(data);
        }
    };
    const searchHandler = (value) => {
        setBomSearchText(value);
    };
    const handleSearchReset = () => {
        var _a;
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.setValue('');
        setBomSearchText('');
        setIsSearching(false);
        setFilteredData({
            groups: (bom === null || bom === void 0 ? void 0 : bom.groups) || [],
            assemblyCharge: (bom === null || bom === void 0 ? void 0 : bom.assemblyCharge) && Object.keys(bom.assemblyCharge).length > 0 ? bom.assemblyCharge : undefined,
        });
    };
    const sizePrecision = (0, react_1.useMemo)(() => {
        var _a;
        if (!bom || !bom.groups) {
            return 0;
        }
        let currentMaxPrecision = 0;
        const sizes = (_a = bom.groups) === null || _a === void 0 ? void 0 : _a.map((group) => group.items.map((item) => {
            var _a, _b;
            return (0, roundNumberWithDecimals_1.default)((_b = (isImperialMeasurement
                ? item.size
                : (0, utils_1.convertToSI)({
                    size: item.size,
                    unitOfMeasurement: (_a = item.unitOfMeasurement) !== null && _a !== void 0 ? _a : '',
                }).size)) !== null && _b !== void 0 ? _b : 0, consts_1.MAX_SIZE_PRECISION);
        })).flat(1);
        for (let i = 0; i < sizes.length; i += 1) {
            if (currentMaxPrecision === consts_1.MAX_SIZE_PRECISION) {
                break;
            }
            sizes[i] *= Math.pow(10, currentMaxPrecision);
            if (Number.isInteger(sizes[i])) {
                // eslint-disable-next-line no-continue
                continue;
            }
            for (let j = currentMaxPrecision + 1; j <= consts_1.MAX_SIZE_PRECISION; j += 1) {
                sizes[i] *= 10;
                if (Number.isInteger(sizes[i]) || j === consts_1.MAX_SIZE_PRECISION) {
                    currentMaxPrecision = j;
                    break;
                }
            }
        }
        return currentMaxPrecision;
    }, [bom === null || bom === void 0 ? void 0 : bom.id, bom === null || bom === void 0 ? void 0 : bom.quantity, bom === null || bom === void 0 ? void 0 : bom.total, isImperialMeasurement]);
    const explosionCoefficientValidator = (value) => {
        if (value && +value < 1) {
            return t('bom.explosion-coefficient-range-error');
        }
        return null;
    };
    const isProd = process.env.NODE_ENV === 'production';
    const bomContent = (0, react_1.useMemo)(() => {
        var _a;
        if (!(bom === null || bom === void 0 ? void 0 : bom.quantity)) {
            return (react_1.default.createElement("div", { className: BOMWidget_scss_1.default.emptyMessage },
                react_1.default.createElement("img", { src: assets_1.svgBasicHideIcon, alt: "Hide icon" }),
                react_1.default.createElement("div", null, t('bom.empty-state'))));
        }
        if (isSearching && filteredData.groups.length === 0 && !filteredData.assemblyCharge) {
            return (react_1.default.createElement("div", { className: BOMWidget_scss_1.default.noResultsMessage },
                t('bom.no-result-found'),
                " ",
                react_1.default.createElement("strong", null, bomSearchText)));
        }
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(BOMItemsList_1.default, { items: filteredData.groups, sourceGroups: bom.groups, sizePrecision: sizePrecision, assemblyCharge: filteredData.assemblyCharge, sourceAssemblyCharge: bom.isAssemblyChargeIncluded ? bom.assemblyCharge : undefined, isSearchActive: isSearching, searchText: bomSearchText }),
            react_1.default.createElement(BOMTotal_1.default, { total: bom.total, discountedTotal: bom.discountedTotal, discount: bom.discount, weight: bom.weight, isAssemblyChargeApplicable: !!((_a = bom.groups) === null || _a === void 0 ? void 0 : _a.find((group) => group.name !== consts_2.MANUALLY_ADDED_ITEMS && group.items.find((item) => item.assemblyTime))), isAssemblyChargeIncluded: bom.isAssemblyChargeIncluded, isAssemblyChargeLoading: isLoading === types_2.LOADING_STATE.LOADING, setAssemblyChargeIncluded: handleSetAssemblyChargeIncluded })));
    }, [bom, filteredData, isSearching, bomSearchText, sizePrecision, handleSetAssemblyChargeIncluded, isLoading]);
    return (react_1.default.createElement(UI_1.Widget, { widgetName: consts_2.WIDGETS.BOM_WIDGET, defaultSize: {
            width: 580,
            height: 595,
        }, defaultPosition: {
            // 668 = 580 widget's width; 72 - margin right, 16 - boundaries margin left
            x: width - 668,
            y: 0,
        }, minSize: {
            height: UI_1.widgetMinHeight,
            width: 472,
        } },
        react_1.default.createElement("div", { "data-testid": "bom-widget", className: BOMWidget_scss_1.default.grid, "data-loading": isWidgetLoading },
            react_1.default.createElement("header", null,
                react_1.default.createElement("div", { className: BOMWidget_scss_1.default.title },
                    react_1.default.createElement("div", null, t('bom.tslots-quote')),
                    react_1.default.createElement("div", null, (_c = bom === null || bom === void 0 ? void 0 : bom.revisionNumber) !== null && _c !== void 0 ? _c : '')),
                react_1.default.createElement(UI_1.Button, { onClick: handleAddItemsClick, active: isEditMode, icon: assets_1.svgQuoteAddBOMItem, disabled: isEditMode ||
                        isOrderCompleted ||
                        isProjectArchived ||
                        isDefaultFastenersWidgetShown ||
                        isCurrentFastenersWidgetShown ||
                        isItemReplacementWidgetShown ||
                        isProjectViewOnly ||
                        isLoading === types_2.LOADING_STATE.LOADING ||
                        isExporting }, t('bom.edit-bom-items'))),
            react_1.default.createElement("main", null,
                isExporting ? (react_1.default.createElement("div", { className: BOMWidget_scss_1.default.exportFeedback },
                    react_1.default.createElement("span", { className: BOMWidget_scss_1.default.exportSpinner }, [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((segment) => (react_1.default.createElement("span", { key: segment })))),
                    t('bom.exporting'))) : null,
                react_1.default.createElement("div", { className: BOMWidget_scss_1.default.searchContainer },
                    react_1.default.createElement(UI_1.Input, { type: "search", placeholder: t('bom.bom-search-bar'), value: bomSearchText, ref: inputRef, onChange: searchHandler })),
                bomContent),
            isEditMode ? (react_1.default.createElement("footer", null,
                react_1.default.createElement(UI_1.Button, { onClick: cancelClickHandle }, t('bom.cancel')),
                react_1.default.createElement(UI_1.Button, { variant: "primary", disabled: !isUpdated || isLoading === types_2.LOADING_STATE.LOADING, onClick: saveClickHandle }, t('bom.save')))) : (react_1.default.createElement("footer", { className: BOMWidget_scss_1.default.flexColumn },
                !isProd && (react_1.default.createElement("div", { className: BOMWidget_scss_1.default.explosionCoefficient },
                    react_1.default.createElement("div", { className: BOMWidget_scss_1.default.subtitle }, t('bom.explosion-coefficient-subtitle')),
                    react_1.default.createElement(UI_1.Input, { placeholder: t('bom.explosion-coefficient-placeholder'), value: explosionCoefficient, type: "number", onInput: (value) => {
                            setExplosionCoefficient(+value);
                        }, validator: explosionCoefficientValidator }))),
                react_1.default.createElement("div", { className: BOMWidget_scss_1.default.actions },
                    react_1.default.createElement("div", { className: BOMWidget_scss_1.default.leftButtonsContainer },
                        react_1.default.createElement("div", null,
                            react_1.default.createElement(BOMExportButton_1.default, { disabled: bom === null || !bom.quantity || isLoading === types_2.LOADING_STATE.LOADING, revisionNumber: bom === null || bom === void 0 ? void 0 : bom.revisionNumber, isImperialMeasurement: isImperialMeasurement, explosionCoefficient: explosionCoefficient })),
                        react_1.default.createElement("div", null,
                            react_1.default.createElement(BOMShareButton_1.default, { disabled: isLoading === types_2.LOADING_STATE.LOADING }))),
                    react_1.default.createElement(UI_1.Button, { variant: "primary", disabled: bom === null ||
                            !bom.quantity ||
                            isDefaultFastenersWidgetShown ||
                            isCurrentFastenersWidgetShown ||
                            isItemReplacementWidgetShown ||
                            isProjectViewOnly ||
                            (projectPermissions === null || projectPermissions === void 0 ? void 0 : projectPermissions.manageSharing) === false ||
                            isBomSubmitDisabled ||
                            isProjectArchived ||
                            isLoading === types_2.LOADING_STATE.LOADING, onClick: saveClickHandle }, t('bom.submit')))))),
        isLoading === types_2.LOADING_STATE.LOADING ? react_1.default.createElement(UI_1.SpinnerLoader, null) : null,
        isBOMFeedbackVisible ? (react_1.default.createElement("div", { className: BOMWidget_scss_1.default.feedback }, feedback ? t(feedback.message) : null)) : null));
}
exports.default = BOMWidget;
